import EndPointConfig, { MockData } from '../../models/api/endPointConfig';

import * as formResetPass from '../mocks/resetPassMock.json';

/// Define all EndPoints for Reset Password contact.
export const ResetPassEP : EndPointConfig[] = [
    // Envio de formulario a la API
];
